import { useEffect, useState } from "react";
import { useParams } from "react-router";
import ResponsiveTable, { Column } from "@/components/Usados/ResponsiveTable";
import ActionMenu from "@/components/Usados/ActionMenu";
import Badge from "@/components/ui/badge/Badge";
import { Pencil, Trash, TrendingUp, TrendingDown } from "lucide-react";
import { Modal } from "@/components/Usados/modal";
import Button from "@/components/ui/button/Button";
import { apiFetch } from "@/service/api";

export default function ListarMovimientos({ onEdit }: any) {
  const { id: proyecto_id } = useParams();
  const [movimientos, setMovimientos] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<number | null>(null);

  const fetchData = async () => {
    const res = await apiFetch(`movimientos/proyecto/${proyecto_id}`);
    if (res.ok) setMovimientos(await res.json());
  };
  useEffect(() => {
    fetchData();
  }, [proyecto_id]);

  const confirmDelete = async () => {
    if (!idToDelete) return;
    await apiFetch(`movimientos/${idToDelete}`, { method: "DELETE" });
    setMovimientos(movimientos.filter((m) => m.id !== idToDelete));
    setIsModalOpen(false);
  };

  const columns: Column<any>[] = [
    {
      label: "Tipo",
      key: "tipo",
      render: (v: any) => (
        <Badge
          color={v === 1 ? "success" : "error"}
          variant="light"
          startIcon={
            v === 1 ? (
              <TrendingUp className="size-3" />
            ) : (
              <TrendingDown className="size-3" />
            )
          }
        >
          {v === 1 ? "Ingreso" : "Gasto"}
        </Badge>
      ),
    },
    {
      label: "Valor",
      key: "valor",
      render: (v: any) => `$ ${Number(v).toLocaleString()}`,
    },
    {
      label: "Actividad Ligada",
      key: "actividad",
      render: (v: any) =>
        v?.nombre ? (
          <Badge color="info">{v.nombre}</Badge>
        ) : (
          <span className="text-xs text-gray-400">Sin actividad</span>
        ),
    },
    { label: "Descripción", key: "descripcion" },
    { label: "Fecha", key: "createdAt", render: (v: any) => v?.split("T")[0] },
    {
      label: "Acciones",
      key: "id",
      render: (_: any, row: any) => (
        <ActionMenu
          actions={[
            {
              label: "Editar",
              icon: <Pencil className="size-4" />,
              onClick: () => onEdit(row),
            },
            {
              label: "Eliminar",
              icon: <Trash className="size-4" />,
              onClick: () => {
                setIdToDelete(row.id);
                setIsModalOpen(true);
              },
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div>
      <ResponsiveTable columns={columns} data={movimientos} />
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        className="max-w-md"
      >
        <div className="p-6">
          <h4 className="font-semibold mb-4">Eliminar movimiento?</h4>
          <div className="flex justify-end gap-3">
            <Button variant="outline" onClick={() => setIsModalOpen(false)}>
              Cancelar
            </Button>
            <Button onClick={confirmDelete} className="bg-red-600">
              Eliminar
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
